
define('viewmodels/pages/start',[
    'underscore',
    'knockout',
    'jquery'
], function (_, ko, $) {
    var DEFAULT_NUMBER_OF_GAMES = 4,
        GAMES_PER_BREAKPOINT = {
            'mobile-portrait': 4,
            'mobile-landscape': 8,
            'tablet-portrait': 6,
            'tablet-landscape': 8
        };

    var StartViewModel = function (
        startPageField,
        pageModuleField,
        gameBrowserField,
        offerSelector,
        gamesInterface,
        mediaResponder
        ) {
        var self = this,
            currentBreakpoint,
            numberOfVisibleGames;

        self.offer = offerSelector.promotedOffer;

        self.meta = {
            title: startPageField('meta_title'),
            description: startPageField('meta_description')
        };

        self.bannerImageUrl = startPageField('banner_image_url');
        self.preHeader = pageModuleField('pre_header');
        self.ctaText = pageModuleField('cta_text');
        self.ctaColor = pageModuleField('cta_color');
        self.logInText = startPageField('log_in_text');
        self.deviceSupport = pageModuleField('device_support');
        self.productTagLines = pageModuleField('product_taglines');
        self.awardLogos = startPageField('awards').withFallback([]).map(function (award) {
            return award.award_image;
        });
        self.paymentMethodLogos = startPageField('payment_methods').withFallback([]).map(function (method) {
            return method.payment_method_image;
        });

        self.slugs = startPageField('game_slugs').withFallback([]);
        self.gamesHeader = gameBrowserField('box_header');
        self.allGamesButtonText = startPageField('all_games_button_text');

        currentBreakpoint = mediaResponder.findBreakpointBy(_.keys(GAMES_PER_BREAKPOINT));

        numberOfVisibleGames = ko.pureComputed(function () {
            return GAMES_PER_BREAKPOINT[currentBreakpoint()] || DEFAULT_NUMBER_OF_GAMES;
        });

        self.games = gamesInterface.findVisibleBySlugs(self.slugs).take(numberOfVisibleGames);

    };

    return StartViewModel;

});

